import React from 'react'
import { Skeleton } from 'antd-mobile'

const SkeletonPage: React.FC = () => {
  const style = {
    '--height': '30px'
  }

  return (
    <div style={{ padding: '10px' }}>
      <Skeleton.Title animated style={style} />
      <Skeleton.Paragraph lineCount={5} animated />
      <Skeleton.Title animated style={style} />
      <Skeleton.Paragraph lineCount={5} animated />
    </div>
  )
}

export default SkeletonPage
